export const API_VERSION = 'v1';
export const LANGUAGES = {
    EN: 'en',
    HI: 'hi',
};
export const DEFAULT_LANGUAGE = LANGUAGES.EN;
export const PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
};
/** Header names shared by every app and the API. */
export const HEADERS = {
    REQUEST_ID: 'x-request-id',
    IDEMPOTENCY_KEY: 'idempotency-key',
    APP_CLIENT: 'x-client',
    LANGUAGE: 'x-language',
};
/** Which frontend a request came from. Used for logging, never for authorization. */
export const CLIENT_APPS = {
    CUSTOMER_WEB: 'customer-web',
    DRIVER_WEB: 'driver-web',
    ADMIN_WEB: 'admin-web',
};
export const BOOKING_REFERENCE_PREFIX = 'PS';
//# sourceMappingURL=app.js.map